
import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Plus, RefreshCw, Filter } from "lucide-react";

interface ReagentRequestPageHeaderProps {
  showFilters: boolean;
  toggleFilters: () => void;
  handleRefresh: () => void;
  isRetrying: boolean;
}

const ReagentRequestPageHeader: React.FC<ReagentRequestPageHeaderProps> = ({
  showFilters,
  toggleFilters,
  handleRefresh,
  isRetrying
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <h1 className="text-3xl font-bold mb-4 md:mb-0">Requested Reagents</h1>
      
      <div className="flex flex-wrap gap-2 w-full md:w-auto">
        <Button 
          onClick={() => navigate("/request-reagent")}
          className="flex items-center gap-1"
        >
          <Plus className="h-4 w-4" />
          Request Reagent
        </Button>
        
        <Button 
          variant="outline" 
          onClick={toggleFilters}
          className="flex items-center gap-1"
        >
          <Filter className="h-4 w-4" />
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
        
        <Button 
          variant="outline" 
          onClick={handleRefresh}
          disabled={isRetrying}
          className="flex items-center gap-1"
        >
          <RefreshCw className={`h-4 w-4 ${isRetrying ? "animate-spin" : ""}`} />
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default ReagentRequestPageHeader;
